<template>

  <!-- Overlay Loading -->
   
  <div v-if="loading" class="vh-100 loading-overlay">
    <div class="text-center">
      <div class="spinner-border text-primary fancy-spinner" role="status"></div>
      <div class="mt-2 fw-semibold">Carregando...</div>
    </div>
  </div>

  <!-- MAPA COMO FUNDO -->
  <div class="map-background">
    <div class="google-map-rota" ref="googleMap"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />
    </template>
  </div>

  <!-- CONTEÚDO SOBREPOSTO -->
  <div class="content-overlay">

    <!-- HEADER / CARD SUPERIOR -->
    <div class="col-12">
      <div class="bg-transparent">
        <div class="bg-transparent">
          <div class="card-body bg-transparent">
            <div class="row gx-4">



              <div class="col-auto my-auto">

                <div class="">
                  <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">

                    <li class="nav-item col-lg-5 col-md-5 col-sm-5 my-auto">
                      <div class="row">
                          <div class="row" >
                            <div class="col-auto">
                              <button class="meu-btn" @click="goClose">
                                X
                              </button>
                            </div>
                          </div>
                          <div class="p-1  col-7 bg-white">
                              Rotas
                          </div>
                          <div class="p-1  col-7 bg-white" v-for="rota in rotasFiltradas">
                              <span class="badge badge-sm bg-success"  @click="toggleUnicRoute(rota)" >{{rota.name}}</span>
                          </div>
                      </div>
                    </li>

                    <li class="nav-item col-lg-5 col-md-5 col-sm-5 my-auto">

                      <Multiselect
                        style="width: 600px;"
                        v-model="janelas"
                        @change="goRefresh"
                        placeholder="Janelas"
                        mode="tags"
                        :close-on-select="false"
                        :searchable="true"
                        :create-option="true"
                        noOptionsText="Nenhuma opção disponível"
                        noResultsText="Nenhum resultado encontrado"
                        multipleLabel="Itens selecionados"
                        optionsLabel="Opções disponíveis"
                        selectLabel="Pressione Enter para selecionar"
                        deselectLabel="Pressione Enter para remover"
                        selectedLabel="Selecionado"
                        :options="[
                          { value: '1', label: '08:00-10:00' },
                          { value: '2', label: '10:00-12:00' },
                          { value: '3', label: '12:00-14:00' },
                          { value: '4', label: '14:00-16:00' },
                          { value: '5', label: '16:00-18:00' },
                          { value: '6', label: '18:00-20:00' },
                        ]"
                      />

                    </li>

                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA / CONTEÚDO -->
    <div class="container-fluid container-bottom">
      <div class="row">

        <div class="col-12" v-if="!no_show">
          <button class="btn btn-danger" @click="goRefresh">
            Recarregar Mapa
          </button>
        </div>

        <div class="col-12">
          <rotas-table-mapa
            :rotas="rotaFiltradas"
            :motoristas="motoristas"
            :veiculos="veiculos"
            :map="map"
            :toggleRoute="toggleRoute"
            :toggleUnicRoute="toggleUnicRoute"
            :alocarVeiculo="setVeiculo"
            :alocarMotorista="setMotoristas"
            :reOrdenar="setOrdem"
            :removerRota="removerRota"
            :salvarRotas="salvarUnico"
            :arquivarRota="arquivarRota"
          />
        </div>

      </div>
    </div>

  </div>
</template>

<style>

.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.fancy-spinner {
  width: 3rem;
  height: 3rem;
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
}

.meu-btn{


    background: none rgb(255, 255, 255);
    border: 0px;
    margin: 10px;
    padding: 0px;
    text-transform: none;
    appearance: none;
 
    cursor: pointer;
    user-select: none;
    border-radius: 2px;
    height: 40px;
    width: 40px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    overflow: hidden;

}
.close-buttom{
   
    top: 0px;
}

.close-buttom span{
   height: 40px;
   color: #000;
} 
  .map-background {
  position: fixed;
  inset: 0;
  z-index: 0;
}

.google-map-rota {
  width: 100%;
  height: 100%;
}


.container-bottom{
  position: fixed;

  bottom: 10px;
}

   .custom-marker {
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      text-align: center;
      border: 2px solid black;
      width: 50px;
      height: 50px;
    }

    .custom-marker img {
      width: 100%;
      border-radius: 50%;
    }
</style>
<script>
import { markRaw } from 'vue';

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { defineComponent, ref , toRaw  } from 'vue';

import RotasTable from "./components/RotasTable.vue";

import RotasTableMapa from "./components/RotasTableMapa.vue";

import ArgonButton from "@/components/ArgonButton.vue";

import Multiselect from '@vueform/multiselect'

import fintailapi from "../api";

import {useStore} from "vuex";

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    RotasTableMapa,
    ArgonButton,
    Multiselect
  },
  data() {
    return {
      map: null,
      google: null,
      loading: false,
      rotas: [],
      rota_selecionada: {},
      clusters_alocados: [],
      janelas: [  "1",  "2",  "3",  "4",  "5",  "6" ],
      motoristas:[],
      veiculos  :[],
      current_page:0,
      total_pages:0,
      no_show:true,
      store : useStore(),
      toast : useToast()
    };
  },
  computed: {
    rotasFiltradas() {
      return this.rotas.filter((rota) => {
        const janelas_nome = [
          { value: '1', label: '08:00-10:00' },
          { value: '2', label: '10:00-12:00' },
          { value: '3', label: '12:00-14:00' },
          { value: '4', label: '14:00-16:00' },
          { value: '5', label: '16:00-18:00' },
          { value: '6', label: '18:00-20:00' },
        ];

        const intervalo = this.getIntervalo(rota);
        if (!intervalo) return false;

        const janelaEncontrada = janelas_nome.find(j => j.label === intervalo);
        if (!janelaEncontrada) return false;

        return this.janelas.includes(janelaEncontrada.value);
      });
    },
     rotaFiltradas() {
      return this.rotas.filter((rota) => {

        if (this.rota_selecionada=={}) return true;

        if (rota==this.rota_selecionada) return true;

        return false;

      });
    }
  },
  async mounted() {
    
    this.store.state.hideConfigButton = true;
    this.store.state.showNavbar = false;
    this.store.state.showSidenav = false;
    this.store.state.showFooter = false;

    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: process.env.VUE_APP_MAPS_APIKEY,
      v:'beta'
    })

    this.google = googleMapApi;
    this.initializeMap()

  },
  methods: {
    getIntervalo(rota) {
      const match = rota.name.match(/\[(.*?)\]/);
      if (!match) return null;
      return match[1].replace("–", "-");
    },
   toggleUnicRoute(rota) {

      this.rota_selecionada = rota
      // Esconde todas as rotas
      this.rotas.forEach(r => {
        r.visible = false;

        if (r._polyline) r._polyline.setMap(null);

        if (r._cluster) {
          // remove do mapa e limpa markers
          r._cluster.clearMarkers();
          //r._cluster.setMap(null);
        }
      });

      // Alterna visibilidade da rota selecionada
      rota.visible = true;

      if (rota._polyline) rota._polyline.setMap(this.map);
      if (Array.isArray(rota._markers) && this.map) {
       
          rota._cluster = markRaw(new MarkerClusterer({
            map: this.map,
            markers: rota._markers,
          }));

          rota._cluster.render()

      }      

    },

    toggleRoute(rota) {

      rota.visible = !rota.visible;

      // Polyline
      //rota._polyline.setVisible(rota.visible);
if(rota.visible)rota._polyline.setMap(this.map);
else rota._polyline.setMap(null);
      //rota._polyline.setMap(null);

      // Cluster (v3 ou @googlemaps/markerclusterer)
      // Se a sua versão não tiver .setMap, use clearMarkers()/addMarkers()
      /*if (rota._cluster.setMap) {
        rota._cluster.setMap(rota.visible ? this.map : null);
      } else if (rota._cluster.clearMarkers) {
        if (rota.visible) {
          rota._cluster.addMarkers(rota._markers, true);
        } else {
          rota._cluster.clearMarkers();
        }
      }*/

    },
    initializeMap() {


      console.log("MAP")
      const mapContainer = this.$refs.googleMap

      this.map = new this.google.maps.Map(
        mapContainer, {  
            clickableIcons: false,
            streetViewControl: false,
            panControlOptions: true,
            gestureHandling: "cooperative",
            mapTypeControl: true,
            styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "on" }]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        }
                    ],
                
            zoomControlOptions: {
              style: "SMALL"
            },

            zoom: 13,
            minZoom: 8,
            maxZoom: 20,
            center: { lat: -22.2941067, lng: -48.5642125 }
        }
      )


      this.map.addListener('zoom_changed', () => {

        //this.rotas.forEach(marker => marker.setVisible(false));

        //const currentZoom = this.map.getZoom();
        //console.log('Zoom atual:', currentZoom);

 
      });

      this.getRotas()

      

    },



    async goClose(){

      this.store.state.hideConfigButton = false;
      this.store.state.showNavbar = true;
      this.store.state.showSidenav = true;
      this.store.state.showFooter = true;


      this.$router.push('/dashboard');

    },
    async goRefresh(){

      this.no_show = true;
      this.loading = false;

      const googleMapApi = await GoogleMapsApiLoader({
        apiKey: process.env.VUE_APP_MAPS_APIKEY,
        v:'beta'
      })

      this.google = googleMapApi;

      this.initializeMap()

    },
    getRota(id) {

      fintailapi
      .get(`/rotas/${id}`)
      .then((response) => {

          const colors = ['#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF']; // Exemplo de cores

          this.current_page = 0;

          let rota = response.data;
          this.total_pages = response.data.count / 10

          const { Polyline, Marker } = this.google.maps;

          const decodedPoints = rota.rota.Caminho.flatMap(segment => [
            { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
            { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
          ]);

          let routePath = new Polyline({
            path: decodedPoints,
            geodesic: true,
            strokeColor: colors[0],
            strokeOpacity: 0.4,
            strokeWeight: 8,
          });

          routePath.setMap(this.map);

          for(let pedido of rota.rota.Pedidos){

              const local = {
                  id: pedido.id_pedido,
                  position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
              };

              new Marker({
                position: local.position,
                marker: local,
                map: this.map,
                icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
              });

          }

          new Marker({
            position: { lat: rota.rota.Operacao.latitude, lng:  rota.rota.Operacao.longitude},
            map:  this.map,
            title: "Centro",
            icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' // Ícone do marcador
          });


      })
      .catch((error) => {

        //this.isOpenRef = true;

      })

    },
    getRotas() {

        fintailapi
        .get(`/rotas`)
        .then(async(response) => {


            this.getMotoristas();

            this.current_page = 0;

            let local_rotas = response.data;

            for(let rota of local_rotas){

              rota.Pedidos.sort((a, b) => a.ordem - b.ordem);

            }


            this.rotas = local_rotas;

            this.total_pages = response.data.count / 10


            const { Polyline, Marker } = this.google.maps;
            const { AdvancedMarkerElement, PinElement } = await this.google.maps.importLibrary("marker");

          
            const colors = [
              '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
              '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
              '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
              '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
              '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
              '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
              '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
            ];
            
            let key = 0;

            for(let rota of this.rotasFiltradas){

              this.rotas[key].color = colors[key % colors.length]

                const decodedPoints = rota.Caminho.flatMap(segment => [
                    { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
                    { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
                ]);


                const total = rota.Caminho.reduce((acc, item, idx) => {
                 
                  return acc + item.distance;
                }, 0);
 
                this.rotas[key].distance = total.toFixed(2);

                
                
                let routePath =  markRaw(new Polyline({
                    path: decodedPoints,
                    geodesic: true,
                    strokeColor: colors[key % colors.length],
                    strokeOpacity: 0.6,
                    strokeWeight: 4
                }));

                routePath.setMap(this.map);




                
                let all_markers = []
                let sequencia = 0;



                let ce =  markRaw(new Marker({
                    position: { lat: rota.Operacao.latitude, lng: rota.Operacao.longitude },
                    title: "Centro",
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                }))
                all_markers.push(ce)



                for(let pedido of rota.Pedidos){

                    const local = {
                        id: pedido.id_pedido,
                        position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
                    };


                  
                    //try {



/*
                    const pinBackground = new PinElement({
                      background: "#FBBC04",
                    });

                     const marker = new AdvancedMarkerElement({
                          position: local.position,
                          content: pinBackground.element,
                          content: customMarkerContent1, // Conteúdo personalizado
                      });*/


                      let marker =  markRaw(new Marker({
                         title: pedido.numero_pedido,

                        position: local.position,
                        // adjust zIndex to be above other markers
                        zIndex: Number(this.google.maps.Marker.MAX_ZINDEX) + pedido.ordem,
                        icon: {
                            url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(`
                              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 1024 1024">
                          <path d="M512 85.333333c-164.949333 0-298.666667 133.738667-298.666667 298.666667
                                  0 164.949333 298.666667 554.666667 298.666667 554.666667s298.666667-389.717333
                                  298.666667-554.666667c0-164.928-133.717333-298.666667-298.666667-298.666667z
                                  m0 448a149.333333 149.333333 0 1 1 0-298.666666 149.333333 149.333333 0 0 1 0 298.666666z"
                                fill="${colors[key % colors.length]}" />
                          <text x="512" y="420" text-anchor="middle" alignment-baseline="middle"
                                font-size="320"  fill="#ffffff">${pedido.ordem}</text>
                        </svg>
                            `),


                        }
                      }))

                      all_markers.push(marker);

                  

                    

                    sequencia++
                }



                ce =  markRaw(new Marker({
                    position: { lat: rota.Operacao.latitude, lng: rota.Operacao.longitude },
                    title: "Centro",
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                }))
                all_markers.push(ce)

                
                //
                let cluster =  markRaw(new MarkerClusterer({
                                                                              map: this.map,
                                                                              markers: all_markers,
                                                                            }));
                
                this.rotas[key]._polyline = routePath;
                this.rotas[key]._cluster  = cluster;
                this.rotas[key]._markers  = all_markers;
                this.rotas[key].visible   = true;


                 /*setTimeout((key) => {
                  console.log(key)
                    key.clearMarkers();
                  }, 3000,  this.rotas[2]._cluster); // Passes "Alice" as an argument to the arrow function
                */
          
                

                key++

            }
         
            //const newLocation = { lat: parseFloat(this.rotas[0].latitude), lng: parseFloat(this.pedidos[0].longitude)  }; // Rio de Janeiro
            //this.map.setCenter(newLocation); // Define o novo centro


        })
        .catch((error) => {
          console.log(error)
          //this.isOpenRef = true;

        })

    },
   getMotoristas() {

          fintailapi
          .get(`/transportadores`)
          .then(async(response) => {

              this.motoristas = response.data.rows;
              this.getVeiculos();

          })
          .catch((error) => { })

    },
    getVeiculos() {

          fintailapi
          .get(`/veiculos`)
          .then(async(response) => {

              this.veiculos = response.data.rows;

          })
          .catch((error) => { })

    },

    setMotoristas(id_veiculo, id_rota, id_transportador){

      fintailapi
      .post(`/transportadores/alocar/${id_veiculo}/${id_rota}/${id_transportador}`,{})
      .then((response) => {
          this.getRotas()
      });

    },
    setVeiculo(id_veiculo, id_rota, id_transportador){

      fintailapi
      .patch(`/rotas/veiculo/${id_rota}/${id_veiculo}`,{})
      .then((response) => {
          this.getRotas()
      });

    },
    setOrdem(pedido, ordem){
      
      //this.no_show = false
      this.loading = true

      fintailapi
      .patch(`/pedidos/reordenar/${pedido.id_pedido}`, pedido)
      .then((response) => {
          
          const sufixo = ordem == null ? '/ordem' : '';
          fintailapi
          .get(`/rotas/processar/${pedido.id_rota}${ sufixo }`)
          .then((response) => {
              this.goRefresh()
          }).catch((error) => {
            this.toast.error(`Erro ao reordenar pedido, tente novamente`);
            this.loading = false
          })

      }).catch((error) => {
        this.toast.error(`Erro ao reordenar pedido, tente novamente`);
        this.loading = false
      })

      

    },
    salvarUnico(rota){
     

      let update = { fixa: rota.fixa }

      fintailapi
      .put(`/rotas/${rota.id}`, update)
      .then((response) => {

        //this.getRotas()

      });

    },
    removerRota(rota){
     
      fintailapi
      .delete(`/rotas/${rota.id}`)
      .then((response) => {

          this.getRotas()

      });

    },
    arquivarRota(rota){
     
      let update = { finalizado: true  }

      fintailapi
      .put(`/rotas/${rota.id}`, update)
      .then((response) => {

        this.getRotas()

      });

    }
    
  },
 
  created() {

  },

});


</script>
